import URL_ROUTE from "../constants/index.js";
import request from "../configs/AxiosWrapper.js";

const EstratificadasService = () => {
  const getToken = () => sessionStorage.getItem("token");

  const getEstratificadas = async ({ ID_USER }) => {
    try {
      const token = getToken();
      if (!token) return;

      return await request(URL_ROUTE.GETESTRATIFICADAS, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ID_USER }),
      });
    } catch (error) {
      throw error;
    }
  };

  return { getEstratificadas };
};

export default EstratificadasService;
